import classnames from 'classnames';
import React from 'react';
import { Field, useField } from 'react-final-form';

import { FormInput } from '../../../../interfaces';
import { useFormInput } from '../../../../libs/hooks';
import { InputLabelComponent } from '../../input-label';
import { InputMessageComponent } from '../../input-message';

export const CheckboxComponent: React.FC<FormInput> = React.memo((props: FormInput) => {
  const { className, description, disabled, label, name, required = true, validators } = props;

  const { id, texts, validate } = useFormInput({
    description,
    disabled,
    label,
    name,
    required,
    validators,
  });

  const metaField = useField(id, { subscription: { error: true, touched: true } });
  const error = metaField.meta.touched && metaField.meta.error;

  return (
    <div
      className={classnames('fr-checkbox-group', className, {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'fr-checkbox-group--error': !!error,
      })}>
      <Field
        aria-describedby={`${id}-messages`}
        component="input"
        id={id}
        name={id}
        type="checkbox"
        validate={validate}
      />
      <InputLabelComponent isCheckbox disabled={disabled} id={id} texts={texts} />
      <InputMessageComponent error={error} id={id} />
    </div>
  );
});

CheckboxComponent.displayName = 'CheckboxComponent';
